module.exports = __webpack_public_path__ + "assets/img/11.efd3e90b.png";